import type { SourcingEventDto } from "../../autogen/bff-api";
import { hasSourcingCreateAccess } from "../../common/auth/utils";
import { isAppShellPath } from "../../common/layout/isAppShellPath";
import { useViewAsRole } from "../../common/subscription/viewAsRoleStore";

export const useCanManageSourcingEvent = (event: SourcingEventDto | undefined) => {
  const previewRole = useViewAsRole();
  const previewAllowsManagement =
    !isAppShellPath(window.location.pathname) || previewRole === null || hasSourcingCreateAccess([previewRole]);
  return (
    previewAllowsManagement &&
    (event?.operations?.some((operation) => operation.operation === "ManageEvent" && operation.allowed) ?? false)
  );
};
